"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _isFunction = _interopRequireDefault(require("./isFunction"));

var deepEqual = function deepEqual(a, b) {
  var objectStack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();
  if (a === b) return true;

  if (a instanceof Error && b instanceof Error) {
    return a.toString() === b.toString();
  }

  var isArrayA = Array.isArray(a);
  var isArrayB = Array.isArray(b);
  if (isArrayA !== isArrayB) return false;

  if (isArrayA && isArrayB) {
    if (a.length !== b.length) return false;
    var arrAKeys = Object.getOwnPropertyNames(a);
    var arrBKeys = Object.getOwnPropertyNames(b);
    if (arrAKeys.length !== arrBKeys.length) return false;

    for (var i = 0, l = arrAKeys.length; i < l; i++) {
      if (!deepEqual(arrAKeys[i], arrBKeys[i], objectStack)) return false;
    }

    for (var _i = 0, _l = a.length; _i < _l; _i++) {
      if (!deepEqual(a[_i], b[_i], objectStack)) return false;
    }

    return true;
  }

  var isSetA = a instanceof Set;
  var isSetB = b instanceof Set;
  if (isSetA !== isSetB) return false;

  if (isSetA && isSetB) {
    if (a.size !== b.size) return false;
    var listA = Array.from(a);
    var listB = Array.from(b);
    return deepEqual(listA, listB, objectStack);
  }

  var isMapA = a instanceof Map;
  var isMapB = b instanceof Map;
  if (isMapA !== isMapB) return false;

  if (isMapA && isMapB) {
    if (a.size !== b.size) return false;

    var _listA = Array.from(a);

    var _listB = Array.from(b);

    return deepEqual(_listA, _listB, objectStack);
  }

  if (a && b && (0, _typeof2["default"])(a) === 'object' && (0, _typeof2["default"])(b) === 'object') {
    // If objects are of the same class and have an 'equals' function, use that.
    if (a.constructor === b.constructor && (0, _isFunction["default"])(a.equals)) {
      return a.equals(b);
    }

    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var dateA = a instanceof Date;
    var dateB = b instanceof Date;
    if (dateA !== dateB) return false;
    if (dateA && dateB) return a.getTime() === b.getTime();
    var regexpA = a instanceof RegExp;
    var regexpB = b instanceof RegExp;
    if (regexpA !== regexpB) return false;
    if (regexpA && regexpB) return a.toString() === b.toString();

    for (var _i2 = 0, _l2 = keysA.length; _i2 < _l2; _i2++) {
      if (!Object.prototype.hasOwnProperty.call(b, keysA[_i2])) return false;
    }

    for (var _i3 = 0, _l3 = keysA.length; _i3 < _l3; _i3++) {
      var objA = a[keysA[_i3]];
      var objB = b[keysA[_i3]]; // Check if we've seen these items before, if so skip over them

      if ((0, _typeof2["default"])(objA) === 'object' && (0, _typeof2["default"])(objB) === 'object') {
        if (objectStack.has(objA) && objectStack.has(objB)) continue;
        objectStack.add(objA);
        objectStack.add(objB);
      }

      if (!deepEqual(objA, objB, objectStack)) return false;
    }

    if (objectStack.has(a)) {
      objectStack["delete"](a);
    }

    if (objectStack.has(b)) {
      objectStack["delete"](b);
    }

    return true;
  }

  return false;
};

var _default = deepEqual;
exports["default"] = _default;